import React, { useContext } from 'react';
export const MapContext = React.createContext(undefined);
export const useOLMap = () => {
    const mapContext = useContext(MapContext);
    if (!mapContext)
        throw new Error('[MapContext] - not defined!');
    return mapContext;
};
//# sourceMappingURL=MapContext.js.map